import { Box, FormControl, Select, TextField, Typography, InputLabel, Stack, Button } from '@mui/material';

export const Location = () => {

    return (
        <Box>
            <Typography variant="body1" color="text.primary" sx={{ fontSize: "1rem", fontWeight: "700" }}>Location<Typography component="span" color="error"> * </Typography></Typography>
            <Box mt="0.5rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Province<Typography component="span" color="error"> * </Typography></Typography>
                <FormControl fullWidth size="small" disabled>
                    <InputLabel id="province-label">Select Province</InputLabel>
                    <Select labelId="province-label" size='small' disabled label="Select Province" sx={{ backgroundColor: "#ffffff", }} value=""></Select>
                </FormControl>
            </Box>
            <Box mt="0.5rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>City<Typography component="span" color="error"> * </Typography></Typography>
                <FormControl fullWidth size="small" disabled>
                    <InputLabel id="city-label">Select City</InputLabel>
                    <Select labelId="city-label" size='small' disabled label="Select City" sx={{ backgroundColor: "#ffffff", }} value=""></Select>
                </FormControl>
            </Box>
            <Box mt="0.5rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Barangay</Typography>
                <FormControl fullWidth size="small" disabled>
                    <InputLabel id="barangay-label">Select Barangay</InputLabel>
                    <Select labelId="barangay-label" size='small' disabled label="Select Barangay" sx={{ backgroundColor: "#ffffff", }} value=""></Select>
                </FormControl>
            </Box>
            <Box mt="0.5rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Street Number</Typography>
                <TextField size='small' fullWidth disabled sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}/>
            </Box>
            <Box mt="1rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "1rem", fontWeight: "700", marginBottom: "0.5rem", }}>Indoor Facilities</Typography>
                <Stack alignItems="center">
                    <Button variant="contained" disabled> Add Indoor Facilities </Button>
                </Stack>
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "1rem", fontWeight: "700", m: "1rem 0rem 0.5rem", }}>Outdoor Facilities</Typography>
                <Stack alignItems="center">
				    <Button variant="contained" disabled> Add Outdoor Facilities </Button>
                </Stack>
            </Box>
        </Box>
    );
};